import { MutationOptions, useMutation } from "react-query";
import { APIError, API_URL_V1, post } from "../api";

export interface CreateAlertAccountResponse {
  IsSuccessful: boolean;
  Message: any;
  [key: string]: any;
}

function useCreateAlertAccount(
  options?: MutationOptions<CreateAlertAccountResponse, APIError, void>
) {
  const {
    isLoading: creatingAlertAccount,
    isError: isCreateAlertAccountError,
    error: createAlertAccountError,
    mutate: createAlertAccount,
    mutateAsync: createAlertAccountAsync,
    data: createAlertAccountData,
  } = useMutation<CreateAlertAccountResponse, APIError, void>(
    async () => {
      return (await post(
        `${API_URL_V1}/accounts/create`,
        {}, // Empty body as confirmed by user
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )) as CreateAlertAccountResponse;
    },
    { ...options }
  );

  return {
    createAlertAccount,
    createAlertAccountAsync,
    creatingAlertAccount,
    isCreateAlertAccountError,
    createAlertAccountError,
    createAlertAccountData,
  };
}

export default useCreateAlertAccount;
